<template>
  <svg
    class="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="26"
    viewBox="0 0 20 26"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 0H12l8 8v15.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 0 23.5v-21A2.5 2.5 0 0 1 2.5 0Zm10 1.9V6A1.5 1.5 0 0 0 14 7.5h4.1L12.5 1.9ZM5 13.5a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H5Zm0 4.5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H5Z"
    />
  </svg>
</template>
